import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OrganizationSearchComponent} from './organization-search/organization-search.component';
import {ServiceProviderGuard} from '../guards/service.provider.guard';
import {ServiceProvidersComponent} from './service-providers.component';
import {EndUserSearchComponent} from './end-user-search/end-user-search.component';
import {ServiceNumberSearchComponent} from '@app/service-provider/service-number-search/service-number-search.component';

const routes: Routes = [
  {
    path: 'search',
    canActivate: [ServiceProviderGuard],
    component: ServiceProvidersComponent,
    data: {tabMenu: true},
    children: [
      {
        path: '',
        redirectTo: 'organization',
        pathMatch: 'full'
      },
      {
        path: 'organization',
        component: OrganizationSearchComponent,
        data: {label: 'global.organizations'}
      },
      {
        path: 'service-numbers',
        component: ServiceNumberSearchComponent,
        data: {label: 'global.service_numbers'}
      },
      {
        path: 'members',
        component: EndUserSearchComponent,
        data: {label: 'admin.tabmenu.employees'}
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceProviderRoutingModule {}
